<template>
  <div>
    <div class="card" style="margin-bottom: 5px; ">
        <el-input clearable style="width: 260px; " v-model="data.name" placeholder="请输入" :prefix-icon="Search"></el-input>
        <!-- <el-input clearable style="width: 260px; " v-model="data.username" placeholder="请输入账号查询" :prefix-icon="Search"></el-input> -->
        <el-button type="primary" style="margin-left: 10px;" @click="load">查 询</el-button>
        <el-button type="danger" style="margin-left: 10px;" @click="reset">重 置</el-button>
    </div>
    <div class="card" style="margin-bottom: 5px; ">
        <el-button type="danger" style="margin-left: 10px;" @click="deleteBatch">批量删除</el-button>
        <el-button @click="handleAdd" type="primary" style="margin-left: 10px;">新 增</el-button>
        <el-upload 
        style="display: inline-block;margin-left: 10px;"
        action="https://jjw-ai.asia/api/admin/import"
        :show-file-list="false"
        :on-success="handleImportSuccess"
        >
        <el-button type="sucess" style="margin-left: 10px;">批量导入</el-button>
        </el-upload>
        
        <el-button type="primary" style="margin-left: 10px;" @click="exportData">批量导出</el-button>
    </div>
    <div class="card" style="margin-bottom: 5px; ">
         <el-table :data="data.tableData" style="width: 100%" @selection-change="handleSelectionChange" :header-cell-style="{color:'#333',backgroundColor:'#eaf4ff'}">
         <el-table-column type="selection" width="55px"></el-table-column>
         <el-table-column label="头像">
              <template #default="scope">
                    <el-image v-if="scope.row.avater" :src="scope.row.avater" :preview-src-list="[scope.row.avater]" style="width: 40px; height: 40px; border-radius: 50%; display: block;" :preview-teleported="true"></el-image>
              </template>
         </el-table-column>
          <el-table-column prop="username" label="账号"  />
         <el-table-column prop="name" label="名称"  />
         <el-table-column prop="phone" label="电话" />
         <el-table-column prop="email" label="邮箱" />
         <el-table-column  label="操作" width="100">
           <template #default="scope">
            <el-button type="primary" icon="Edit" circle @click="handleEdit(scope.row)"></el-button>
            <el-button type="danger" icon="Delete" circle @click="del(scope.row.id)"></el-button>
           </template>
         </el-table-column>
  </el-table>
    </div>
  <div class="card">
      <el-pagination
        v-model:current-page="data.pageNum"
        v-model:page-size="data.pageSize"
        
        layout="total, sizes, prev, pager, next,jumper"
        :page-sizes="[5,10,20]"
        :total="data.total"
        @current-change="load"
        @size-change="load"
        
        
    />
  </div>
    <!-- :page-size="data.pageSize" -->
     <el-dialog v-model="data.formVisible" title="客户信息" width="30%" destroy-on-close>
    <el-form ref="formRef" :model="data.form" label-width="80px" :rules="data.rules" style="padding: 20px 30px 20px 0">
      <el-form-item prop="username" label="账号" >
        <el-input v-model="data.form.username" autocomplete="off" />
      </el-form-item>
      <el-form-item label="名称" >
        <el-input v-model="data.form.name" autocomplete="off" />
      </el-form-item>
      <el-form-item label="电话" >
        <el-input v-model="data.form.phone" autocomplete="off" />
      </el-form-item>
      <el-form-item label="邮箱" >
        <el-input v-model="data.form.email" autocomplete="off" />
      </el-form-item>
      <el-form-item label="角色" >
        <el-input v-model="data.form.role" autocomplete="off" />
      </el-form-item>
      <el-form-item prop="avater" label="头像" >
        <el-upload 
        action="https://jjw-ai.asia/api/files/upload"
        :on-success="handleFileSuccess"
        :headers="{token: data.user.token}"
        list-type="picture"
        >
            <el-button type="primary">上传头像</el-button>
          </el-upload>
       </el-form-item>
      
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="data.formVisible = false">取 消</el-button>
        <el-button type="primary" @click="save">
          保 存
        </el-button>
      </div>
    </template>
  </el-dialog>
  </div>
  
  <div>
      <!-- <el-icon><CirclePlus /></el-icon> -->
  </div>
</template>

<script setup>
import {reactive,ref} from "vue"
import {Search} from "@element-plus/icons-vue"
import axios from "axios"
import request from "@/utils/request.js"
import {ElMessage,ElMessageBox} from "element-plus"

const data = reactive({
  user:JSON.parse(localStorage.getItem('code_user') || "{}"),
  username:null,
  name:null,
  pageNum:1,
  pageSize:5,
  total:0,
  tableData:[
    // {name:'青哥哥',phone:'18501703666',address:'北京市朝阳区'},
    // {name:'青哥哥',phone:'18501703666',address:'北京市朝阳区'},
    // {name:'青哥哥',phone:'18501703666',address:'北京市朝阳区'}
  
  ],
  formVisible:false,
  form:{

  },
  rules:{
    username:[
      {required: true, message:'请填写账号',trigger:'blur'}
    ]
  },
  rows:[],
  ids:[]
})
// axios.get('http://localhost:9999/admin/selectAll').then(res=>{
//   console.log(res)
// }
// )
// request.get('/admin/selectAll').then(res => {
//   if(res.code === '200'){
//       console.log(res)
//   }else{
//     ElMessage.Error(res.msg)
//   }
  
//   }
// )
const formRef = ref()



const load = () => {
  request.get('/admin/selectPage',{
    params:{
      pageNum:data.pageNum,
      pageSize:data.pageSize,
      name:data.name,
      username:data.username
    }
  }).then(res=>{
    if(res){
      if( res.code === '200'){
          data.tableData = res.data.list
          data.total = res.data.total

      }else{
        ElMessage.error(res.msg)
      }
    }


  })
}
load()

const reset = () => {
  data.name = null;
  data.username = null;
  load()
}

const handleAdd =() => {
  data.formVisible = true
  data.form = {}
  
}

const add = () => {
  // formRef.value.Validate
  formRef.value.validate((valid) => {
    if(valid){
        request.post('/admin/add',data.form).then(res => {
    if(res.code === '200'){
        data.formVisible = false
        ElMessage.success('新增成功');
        load()

    }else{
      ElMessage.error(res.msg)
    }
   })
    }
  })
}

const handleEdit = (row) => {
    data.form = JSON.parse(JSON.stringify(row))
    data.formVisible = true
}

const update = () =>{
  formRef.value.validate((valid) => {
    if(valid){
        request.put('/admin/update',data.form).then(res => {
    if(res.code === '200'){
        data.formVisible = false
        ElMessage.success('修改成功');
        load()

    }else{
      ElMessage.error(res.msg)
    }
   })
    }
  })
}

const save = () =>{
  data.form.id ? update():add()
}
const del = (id) => {
  
  ElMessageBox.confirm('删除后无法恢复，您确认删除吗','确认删除',{type:'warning'}).then(res => {
    request.delete('/admin/delete/'+id).then(res => {
    if(res.code === '200'){
        
        ElMessage.success('删除成功');
        load()

    }else{
      ElMessage.error(res.msg)
    }
   })
    
  
  }).catch(err => {})
}
const handleSelectionChange = (rows) => {
    data.rows = rows
    data.ids = data.rows.map(v => v.id)
}
const deleteBatch =() => {
  if(data.rows.length ===0){
      ElMessage.warning('请选择数据')
      return
  }
  ElMessageBox.confirm('删除后无法恢复，您确认删除吗','确认删除',{type:'warning'}).then(res => {
    request.delete('/admin/deleteBatch',{data:data.rows}).then(res => {
    if(res.code === '200'){
        
        ElMessage.success('批量删除成功');
        load()

    }else{
      ElMessage.error(res.msg)
    }
   })
    
  
  }).catch(err => {})
}
const exportData = () =>{
  let idsStr = data.ids.join(",")  //把数组转换成字符串
  let url = `https://jjw-ai.asia/api/admin/export?username=${data.username === null ? '' : data.username}`+
  `&name=${data.name === null ? '' :data.name }`+ `&ids=${idsStr}`+`&token=${data.user.token}`
  window.open(url)
}
const handleImportSuccess = () => {
  ElMessage.success("导入成功")
  load()
}

const handleFileSuccess = (res) => {
    data.form.avater = res.data
}
</script>